export default "__VITE_ASSET__CT1snN5v__"